<template>
  <div>
    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/landing/logo_black.png" searchImgSrc="../../../../static/img/landing/search_black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">
          <header class="innovation-PageTitle">
            <div class="innovation-PageTitle_Inner">
              <h1 class="company-PageTitle_Inner_Title" data-appear="">
                <span class="company-PageTitle_Logo"><b>INNOVATION</b></span>
                <span class="company-PageTitle_Title"><b>経営革新</b></span>
              </h1>

              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target">
                        <div class="company-PageTitle_Slide">
                          <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../../static/img/landing/childpageimg3.png) 20%/cover no-repeat;"></div>
                          <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../../static/img/landing/childpageimg3.png) 20%/cover no-repeat;"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="innovation-Guzzilla">
            <div class="innovation-Guzzilla_Inner">
              <h2 class="innovation-Title">経営革新計画の概要</h2>
               <h3 class="product-Detail_Column-text"><b>オーダーメイドに応えるＮＣ旋盤用ロボットの開発、販売及びアフターサービスの展開</b></h3>
              <p class="product-Detail_Column-text">当社は、切削部品を中心に輸出入業務とNC旋盤、フライス盤を導入して自ら高精度部品の加工を行っている。<br>
              今回の経営革新では、切削加工技術を保有している当社がユーザー目線で顧客の使用方法を収集して、希望の機能も付加するオーダーメイドのロボットを開発、販売する。
              基本的には、チャッカ―タイプのNC旋盤は材料の供給や加工後のピックアップは手動で行っており、対策としてパーツフィーダ―の活用やロボットを使い自動化を推進しているが、
              供給、排出作業の合理化だけに留まっている。そこで当社では、顧客の使用方法や要望事項を把握しさらなる合理化が可能なオーダーメイドのロボットを開発、販売する。
              また、ロボット導入時の技術指導や対象となる加工部品が変わった場合の新たな仕様要求にも対応するアフターサービス及びロボットのメンテナンス作業も対応する。
              NC旋盤用ロボットは被加工材の交換（供給、排出機能）に特化した物が多く、個々の顧客の要望に合わせた仕様で製作し技術指導を行い、量産稼働や対象部品が変わった場合までフォローしていく。<br>
              本取り組みにより、ホームページやパンフレットの制作、展示会、商談会に参加し、周知していくことで当社の経営革新を達成する。</p>
              <div class="innovation-Guzzilla_Slide swiper-container swiper-container-initialized swiper-container-horizontal" data-appear="true">
                <ul class="swiper-wrapper">
                  <li class="swiper-slide">
                    <a href="../../../../static/img/landing/innovation01.pdf" target="_blank" rel="noopener noreferrer">
                      <picture><img src="../../../../static/img/landing/innovation01.png" alt=""></picture>
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="../../../../static/img/landing/innovation01.pdf" target="_blank" rel="noopener noreferrer">
                      <picture><img src="../../../../static/img/landing/innovation02.png" alt=""></picture>
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="../../../../static/img/landing/innovation01.pdf" target="_blank" rel="noopener noreferrer">
                      <picture><img src="../../../../static/img/landing/innovation03.png" alt=""></picture>
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="../../../../static/img/landing/innovation01.pdf" target="_blank" rel="noopener noreferrer">
                      <picture><img src="../../../../static/img/landing/innovation04.png" alt=""></picture>
                    </a>
                  </li>
                </ul>
                <div class="swiper-button-next swiper-button-next-Guzzilla"><i class="icf el-icon-arrow-right"></i></div>
                <div class="swiper-button-prev swiper-button-prev-Guzzilla"><i class="icf el-icon-arrow-left"></i></div>
              </div>
            </div>
          </section>

        </main><!-- /.st-MainContents -->
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <a class="st-BreadcrumbsList_Item-link" href="/" itemprop="item">ホーム</a>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">経営革新</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
      innovationGuzzillaSwiper: '',
      innovationExhibitionSlide: ''
    }
  },
  mounted() {
    this.init()
    // innovation-Guzzilla_Slide
  },
  methods: {
    init() {
      $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
      $('.company-Message_Inner').eq(0).addClass('appear')
      this.innovationGuzzillaSwiper = new Swiper('.innovation-Guzzilla_Slide', {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next-Guzzilla',
          prevEl: '.swiper-button-prev-Guzzilla'
        }
      })
      this.innovationExhibitionSlide = new Swiper('.innovation-Exhibition_Slide', {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next-Exhibition',
          prevEl: '.swiper-button-prev-Exhibition'
        }
      })

      // element.offsetHeight
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        console.log(scroH)
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH >= 300) {
            $('.company-PageTitle_Inner_Title').eq(0).removeClass('appear')
          } else {
            $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
          }
          if (scroH > 0 && scroH <= 1200) {
            $('.innovation-Guzzilla_Slide').eq(0).addClass('appear')
          } else {
            $('.innovation-Guzzilla_Slide').eq(0).removeClass('appear')
          }
          if (scroH >= 800 && scroH <= 1900) {
            $('.innovation-Exhibition_Slide').eq(0).addClass('appear')
          } else {
            $('.innovation-Exhibition_Slide').eq(0).removeClass('appear')
          }
        } else {
          $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
          $('.innovation-Guzzilla_Slide').eq(0).addClass('appear')
          $('.innovation-Exhibition_Slide').eq(0).addClass('appear')
        }

        // appear
      })
    }
  }
}
</script>
<style scoped>

  .swiper-button-next i:before,
  .swiper-button-prev i:before {
    font-size: 1.6rem;
    height: 25px;
    line-height: 25px;
    letter-spacing: 0;
    font-weight: bold;
  }

  @media screen and (min-width: 769px) {

    .st-News_Slide .swiper-button-next i:before,
    .st-News_Slide .swiper-button-prev i:before {
      font-size: 2.5rem;
      height: 25px;
      line-height: 25px;
      letter-spacing: 0;
      font-weight: bold;
    }
  }
.innovation-Exhibition_Slide{
  overflow: visible;
}
.innovation-Guzzilla_Slide {
    overflow: visible;
}
.innovation-Exhibition_Slide>>>.swiper-slide {
  width: 475.5px !important;
  margin-right: 43px !important;

}
.innovation-Guzzilla>>>.swiper-slide {
   width: 220px !important;
   margin-right: 38px !important;
}
.innovation-Guzzilla>>>img {
   object-fit:cover;
   height: 296px !important;
}
 a {
    border-bottom-style: none;
  }
  .home>>>.st-Nav_List-en {
    color: #222;
  }

  .home>>> .st-Nav_List-ja {
    color: #222;
  }

  .home>>> .st-Header {
    background-color: #fff;
    border-bottom: 1px solid #ddd;

  }

  .home>>>.innovation font {
    color: #c7000b
  }

  .home>>>.innovation:after {
    transform: scaleX(1) !important;
  }
  @media screen and (max-width: 769px) {
    .innovation-PageTitle{
      padding-top: 0px !important;
      margin-top: -5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/innovation/innovation.vue